import { NavLink } from "react-router-dom";

const Capability = () => {

    return (
      <>
        <article className="flex w-0 flex-1 flex-col gap-6 py-10">
          <div className="prose">
            <h1>Функционал</h1>
            <h2 className="scroll-m-20" id="multisearch">
                <a href="#multisearch" className="not-prose group">Многозадачный поиск и расчет запчастей
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <p className="mb-4">
                Наша уникальная технология позволяет одновременно искать несколько запчастей и моментально получать их стоимость.            
            </p>
            <p>
                Одновременный ввод запросов: Вы можете указать сразу несколько запчастей — система автоматически обработает их и найдет все нужные позиции в каталоге.
                Мгновенный расчет стоимости: Полная стоимость всех запчастей с учетом доставки рассчитывается в реальном времени.
                Удобное сравнение вариантов: Если есть альтернативные детали или поставщики, система предложит вам несколько решений, чтобы вы могли выбрать оптимальный вариант.
                Эта функция значительно экономит ваше время и упрощает процесс планирования ремонта, особенно если вам нужно заказать сразу несколько позиций.        
            </p>
            <h2 className="scroll-m-20" id="search">
                <a href="#search" className="not-prose group">Интеллектуальный поиск и фильтры
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <p className="mb-4">
                Удобный поиск по VIN-коду автомобиля — система автоматически находит запчасти, подходящие именно для вашей модели.            
            </p>
            <p>
                Мгновенные фильтры по характеристикам: бренды, размеры, совместимость. Вы быстро находите нужный товар среди тысячи позиций.      
            </p>
            <h2 className="scroll-m-20" id="catalog">
                <a href="#catalog" className="not-prose group">Обширный каталог запчастей
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <p>
                Самые популярные и редкие детали для всех марок и моделей.
                Товары от проверенных поставщиков с гарантией качества.
                Актуальные остатки и цены в реальном времени.            
            </p>
            <h2 className="scroll-m-20" id="logistics">
                <a href="#logistics" className="not-prose group">Интеграция с логистикой
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <ul>
              <li>Отслеживание каждого этапа доставки: от подтверждения заказа до получения;</li>
              <li>Информация об ориентировочном времени доставки прямо в личном кабинете;</li>
              <li>Уведомления о статусе заказа: вы всегда в курсе, где находится ваша покупка.</li>
            </ul>
            <h2 className="scroll-m-20" id="lk">
                <a href="#lk" className="not-prose group">Личный кабинет пользователя
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <ul>
              <li>История заказов: просматривайте все свои предыдущие покупки;</li>
              <li>Управление доставкой: изменяйте адрес или время доставки, если ваши планы изменились;</li>
              <li>Гибкие способы оплаты: онлайн-платежи, оплата при получении или рассрочка.</li>
            </ul>
            <h2 className="scroll-m-20" id="compare">
                <a href="#compare" className="not-prose group">Возможность сравнения товаров
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <p>
                Сравнивайте несколько позиций по цене, характеристикам и отзывам.
                Удобная визуализация разницы между продуктами.           
            </p>
            <h2 className="scroll-m-20" id="reviews">
                <a href="#reviews" className="not-prose group">Отзывы и рейтинг продавцов
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <p>
                Система честных отзывов от других покупателей.
                Оценки надежности поставщиков, чтобы вы могли делать только осознанный выбор.         
            </p>
            <h2 className="scroll-m-20" id="support">
                <a href="#support" className="not-prose group">Поддержка клиентов
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-link ml-2 inline size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" aria-label="Link to section">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71">

                    </path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71">
                    </path>
                    </svg>
                </a>
            </h2>
            <p className="mb-4">
                Онлайн-чат с технической поддержкой: специалисты помогут с выбором или решением проблемы.
                Автоматизированная справочная система для быстрого ответа на часто задаваемые вопросы.     
            </p>
            <p>
                Наш проект сочетает в себе самые современные технологии и глубокое понимание потребностей 
                автолюбителей, чтобы сделать процесс обслуживания вашего автомобиля максимально комфортным!       
            </p>
          </div>
          <div className="mt-4 flex flex-row flex-wrap gap-4 border-t py-12">
            <NavLink className="flex flex-row items-center gap-2 text-muted-foreground transition-colors hover:text-foreground ms-auto" to="/faq">
              <p className="text-end font-medium text-foreground">
                Вопрос - ответ
              </p>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-chevron-right size-5 shrink-0 rtl:rotate-180">
                <path d="m9 18 6-6-6-6">
                </path>
              </svg>
            </NavLink>
          </div>
        </article>
      </>
    );
  };
  
  export default Capability;